<template>
  <b-card class="m-3" no-body>
    <template #header>
      <h6 class="mb-0 text-center">
        <span class="titulo-sagres font-weight-bold">
          Detalhes de Entrega de relatório da LRF e CI
        </span>
        <btn-voltar url="/entrega/relatorios-lrf-ci" />
      </h6>
    </template>
    <b-card-body>
      <b-row class="text-justify mb-3" v-if="prestacao && prestacao.UnidgestoraRelatorioLrfci">
        <b-col cols="12">
          <span>ID: </span>
          <span>{{ prestacao.IdPrestcontasLrfci }}</span>
        </b-col>
        <b-col cols="12">
          <span>CPF de entrega: </span>
          <span>{{ prestacao.UsuarioEntrega }}</span>
        </b-col>
        <b-col cols="12">
          <span>Ano: </span>
          <span>{{ prestacao.Ano }}</span>
        </b-col>
        <b-col cols="12">
          <span>Tipo de Relatório: </span>
          <span>{{ prestacao.UnidgestoraRelatorioLrfci.TipoRelatorioLrfci.DeTiporelatorio }}</span>
        </b-col>
        <b-col cols="12">
          <span>Período do Relatório: </span>
          <span>{{ prestacao.UnidgestoraRelatorioLrfci.PeriodoRelatorioLrfci.DePeriodorelatorio }}</span>
        </b-col>
        <b-col cols="12">
          <span>Data de Entrega: </span>
          <span>{{ prestacao.DataEntrega.toLocaleDateString() }}</span>
        </b-col>
        <b-col cols="12">
          <span>Situação: </span>
          <span>{{ prestacao.PcmStatusPc.DsStatusPc }}</span>
        </b-col>
        <b-col cols="6" class="text-center mt-2">
          <BtnDownload v-if="podeBaixarArquivo" :fazerDownload="downloadArquivo" texto="Cópia da Entrega" />
        </b-col>
        <b-col cols="6" class="text-center mt-2">
          <BtnDownload :fazerDownload="downloadRecibo" texto="Recibo de Entrega" />
        </b-col>
      </b-row>
    </b-card-body>
    <modal-pdf v-if="exibirModalPdf" @fecharModal="exibirModalPdf = false" :pdfData="pdfData" filename="recibo-lrf" />
  </b-card>
</template>

<script lang="ts">
import ModalPdf from "@/components/ModalPdf.vue";
import BtnVoltar from '@/components/shared/BtnVoltar.vue';
import BtnDownload from "@/components/shared/btn-download.vue";
import lrfService from "@/services/entregas/lrfService";
import { store, isAdmin } from "@/store";
import { PortalError } from "@/types/portal-error";
import { UtilsTS } from '@/utilsts';
import { mixins } from 'vue-class-component';
import { Component, Vue } from 'vue-property-decorator';

const CompProps = Vue.extend({
  name: 'DetalhesRelatorioLRFCI',
  components: { BtnVoltar, BtnDownload, ModalPdf },
  props: {
    relatorio: {
      type: String
    }
  },
})

@Component
export default class DetalhesRelatorioLRFCI extends mixins(UtilsTS, CompProps) {
  prestacao: any = {}

  pdfData = ''
  exibirModalPdf = false

  /**
   * Download de entrega liberado para qualquer entrega menos IRPF.
   * IRPFs só podem ser baixados pelo próprio usuário que fez a entrega.
   */
  get podeBaixarArquivo(): boolean {
    if (this.prestacao?.UnidgestoraRelatorioLrfci?.TipoRelatorioLrfci?.SgTiporelatorio !== 'IRPF') return true
    if (store.cpf == this.prestacao?.UsuarioEntrega || isAdmin()) return true
    return false
  }

  async mounted() {
    try {
      store.blockScreen = true
      this.prestacao = await lrfService.getLRFById(Number(this.relatorio))
      //console.log(this.prestacao)
    } catch (e: any) {
      this.$toast.error(e.message ? e.message : e);
      this.$router.push('/entrega/relatorios-lrf-ci');
    } finally {
      store.blockScreen = false
    }
  }

  async downloadArquivo(): Promise<void> {
    if (!this.podeBaixarArquivo) return
    const response = await lrfService.downloadEntrega(this.prestacao.IdPrestcontasLrfci);
    if (response && response.status == 200) {
      this.download(`entrega-lrfci-${this.prestacao.IdPrestcontasLrfci}`, response.data);
    } else {
      if (response && response.data && response.data.msg)
        this.$toast.error(response.data.msg);
      else this.$toast.error("Erro ao obter o arquivo");
    }
  }
  async downloadRecibo(): Promise<void> {
    this.exibirModalPdf = false
    this.pdfData = ''
    try {
      const response = await lrfService.downloadRecibo(this.prestacao.IdPrestcontasLrfci);
      if (response.ArquivoPdf) {
        const blob = this.base64ToPdf(response.ArquivoPdf)
        this.pdfData = URL.createObjectURL(blob)
        this.exibirModalPdf = true;
      } else throw new PortalError('Erro ao obter o recibo da LRF')
    } catch (e: any) {
      this.tratarError(e);
    }
  }
  //não consegui chamar o mixin
  download(filename, content): void {
    var element = document.createElement('a');
    element.setAttribute('href', URL.createObjectURL(content));
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }
};
</script>
<style scoped>
div.row>div>span:first-child {
  font-weight: bolder;
  /*display: block;*/
}
</style>